module.exports = __webpack_public_path__ + "img/code-text.828c942b.png";